import UI_STRINGS from "./UI-Strings.json"

export const FORM_UI_STRINGS=UI_STRINGS.form
export const LAYOUT_UI_STRINGS=UI_STRINGS.layout
export const TAALY_UI_STRINGS=UI_STRINGS.taaly